import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang:'zh' // 默认语言为中文
  },
  mutations: {
    setLang(state, lang) {
      state.lang = lang;
      localStorage.setItem('lang', lang);
    }
  },
  actions: {
    changeLang({ commit }, lang) {
      commit('setLang', lang);
    }
  }
});